import { Navigate, useParams } from 'react-router';

import guidedSellingExperienceNavigation from '../../pages/GuidedSellingExperience/navigation';
import useLastLeadId from '../../queries/people/useLastLead';

const LastLeadRedirect = () => {
  const { personGid } = useParams();

  const { data: lead, isFetched } = useLastLeadId(personGid);

  if (isFetched && lead) {
    return <Navigate replace to={guidedSellingExperienceNavigation.forLead({ lead_gid: lead.gid })} />;
  }

  if (isFetched && !lead && personGid) {
    return <Navigate replace to={guidedSellingExperienceNavigation.forPerson({ person_gid: personGid })} />;
  }

  return null;
};

export default LastLeadRedirect;
